import { log } from "../../../../../redux/modules/logger/actions";
import { FileUploadManager } from "@traceair/bsp-sdk";
import config from "../../../../../config";
import { EVENT_FROM_BACKOFFICE_STORAGE_PROXY } from "../../../../../redux/modules/logger/constants";
import { pushMetric } from "../../../../../redux/modules/metrics/actions";
import { AppDispatch } from "../../../../../store";
import { getSiteLevelToken } from "../../../../../redux/accessTokenManagerActions";
import { escapeFile } from "../fileModule";

export default function (
  file: File,
  customerId: string,
  siteId: string,
  uploadPath: string,
  dispatch: AppDispatch,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const {
      partSizeBytes,
      requestTimeoutMs,
      maxRetries,
      retryIntervalMs,
      maxParallelRequests,
    } = config.singleFileUpload;
    const uploadManager = new FileUploadManager(escapeFile(file), {
      customerId,
      siteId,
      uploadPath,
      partSizeBytes,
      requestTimeoutMs,
      retryIntervalMs,
      maxRetries,
      maxParallelRequests,
      bspHost: config.endpoints.backofficeStorage,
      onUploadCompleted: ({ filePath }) => {
        // This should be done in BSP SDK, it should return S3 url instead of filePath
        const { s3ExchangeBucket, s3Endpoint } =
          config.hackForCreatingS3LinkForBws;
        resolve(`https://${s3Endpoint}/${s3ExchangeBucket}/${filePath}`);
      },
      onUploadFailed: (err: Error) => {
        reject(err);
      },
      metricFunction: (metricName, metricValue) => {
        dispatch(pushMetric(metricName, metricValue));
      },
      logFunction: (message) => {
        dispatch(log(EVENT_FROM_BACKOFFICE_STORAGE_PROXY, "1", message));
      },
      getJwtToken: async () => {
        return dispatch(getSiteLevelToken(customerId, siteId));
      },
    });
    uploadManager.startUpload();
  });
}
